/*!
 * Copyright (c) 2017-2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var constants = require('../constants');

var jsonld = require('jsonld');

var util = require('../util');

var LinkedDataProof = require('./LinkedDataProof');

module.exports = /*#__PURE__*/function (_LinkedDataProof) {
  _inherits(LinkedDataSignature, _LinkedDataProof);

  /**
   * @param type {string} Provided by subclass.
   *
   * One of these parameters is required to use a suite for signing:
   *
   * @param [creator] {string} A key id URL to the paired public key.
   * @param [verificationMethod] {string} A key id URL to the paired public key.
   *
   * Advanced optional parameters and overrides:
   *
   * @param [proof] {object} a JSON-LD document with options to use for
   *   the `proof` node (e.g. any other custom fields can be provided here
   *   using a context different from security-v2).
   * @param [date] {string|Date} signing date to use if not passed.
   * @param [useNativeCanonize] {boolean} true to use a native canonize
   *   algorithm.
   */
  function LinkedDataSignature() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref.type,
        creator = _ref.creator,
        verificationMethod = _ref.verificationMethod,
        proof = _ref.proof,
        date = _ref.date,
        useNativeCanonize = _ref.useNativeCanonize;

    _classCallCheck(this, LinkedDataSignature);

    // validate common options
    if (verificationMethod !== undefined && typeof verificationMethod !== 'string') {
      throw new TypeError('"verificationMethod" must be a URL string.');
    }

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinkedDataSignature).call(this, {
      type: type
    }));
    _this.creator = creator;
    _this.verificationMethod = verificationMethod;
    _this.proof = proof;

    if (date !== undefined) {
      _this.date = new Date(date);

      if (isNaN(_this.date)) {
        throw TypeError("\"date\" \"".concat(date, "\" is not a valid date."));
      }
    }

    _this.useNativeCanonize = useNativeCanonize;
    return _this;
  }
  /**
   * @param document {object} to be signed.
   * @param purpose {ProofPurpose}
   * @param documentLoader {function}
   * @param expansionMap {function}
   * @param compactProof {boolean}
   *
   * @returns {Promise<object>} Resolves with the created proof object.
   */


  _createClass(LinkedDataSignature, [{
    key: "createProof",
    value: function () {
      var _createProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var document, purpose, documentLoader, expansionMap, compactProof, proof, date, verifyData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document = _ref2.document, purpose = _ref2.purpose, documentLoader = _ref2.documentLoader, expansionMap = _ref2.expansionMap, compactProof = _ref2.compactProof;

                if (!this.proof) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return jsonld.compact(this.proof, constants.SECURITY_CONTEXT_URL, {
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactToRelative: false
                });

              case 4:
                proof = _context.sent;
                _context.next = 8;
                break;

              case 7:
                // create proof JSON-LD document
                proof = {
                  '@context': constants.SECURITY_CONTEXT_URL
                };

              case 8:
                // ensure proof type is set
                proof.type = this.type; // set default `now` date if not given in `proof` or `options`

                date = this.date;

                if (proof.created === undefined && date === undefined) {
                  date = new Date();
                } // ensure date is in string format


                if (date !== undefined && typeof date !== 'string') {
                  date = util.w3cDate(date);
                } // add API overrides


                if (date !== undefined) {
                  proof.created = date;
                } // `verificationMethod` is for newer suites, `creator` for legacy


                if (this.verificationMethod !== undefined) {
                  proof.verificationMethod = this.verificationMethod;
                }

                if (this.creator !== undefined) {
                  proof.creator = this.creator;
                } // add any extensions to proof (mostly for legacy support)


                _context.next = 17;
                return this.updateProof({
                  document: document,
                  proof: proof,
                  purpose: purpose,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactProof: compactProof
                });

              case 17:
                proof = _context.sent;
                _context.next = 20;
                return purpose.update(proof, {
                  document: document,
                  suite: this,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 20:
                proof = _context.sent;
                _context.next = 23;
                return this.createVerifyData({
                  document: document,
                  proof: proof,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactProof: compactProof
                });

              case 23:
                verifyData = _context.sent;
                _context.next = 26;
                return this.sign({
                  verifyData: verifyData,
                  document: document,
                  proof: proof,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 26:
                proof = _context.sent;
                return _context.abrupt("return", proof);

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createProof(_x) {
        return _createProof.apply(this, arguments);
      }

      return createProof;
    }()
    /**
     * @param document {object} to be signed.
     * @param purpose {ProofPurpose}
     * @param documentLoader {function}
     * @param expansionMap {function}
     * @param compactProof {boolean}
     *
     * @returns {Promise<object>} Resolves with the created proof object.
     */

  }, {
    key: "updateProof",
    value: function () {
      var _updateProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var proof;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                proof = _ref3.proof;
                return _context2.abrupt("return", proof);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function updateProof(_x2) {
        return _updateProof.apply(this, arguments);
      }

      return updateProof;
    }()
    /**
     * @param proof {object} the proof to be verified.
     * @param document {object} the document the proof applies to.
     * @param purpose {ProofPurpose}
     * @param documentLoader {function}
     * @param expansionMap {function}
     * @param compactProof {boolean}
     *
     * @returns {Promise<{object}>} Resolves with the verification result.
     */

  }, {
    key: "verifyProof",
    value: function () {
      var _verifyProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
        var proof, document, purpose, documentLoader, expansionMap, compactProof, verifyData, verificationMethod, verified, purposeResult;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                proof = _ref4.proof, document = _ref4.document, purpose = _ref4.purpose, documentLoader = _ref4.documentLoader, expansionMap = _ref4.expansionMap, compactProof = _ref4.compactProof;
                _context3.prev = 1;
                _context3.next = 4;
                return this.createVerifyData({
                  document: document,
                  proof: proof,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactProof: compactProof
                });

              case 4:
                verifyData = _context3.sent;
                _context3.next = 7;
                return this.getVerificationMethod({
                  proof: proof,
                  document: document,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 7:
                verificationMethod = _context3.sent;
                _context3.next = 10;
                return this.verifySignature({
                  verifyData: verifyData,
                  verificationMethod: verificationMethod,
                  document: document,
                  proof: proof,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 10:
                verified = _context3.sent;

                if (verified) {
                  _context3.next = 13;
                  break;
                }

                throw new Error('Invalid signature.');

              case 13:
                _context3.next = 15;
                return purpose.validate(proof, {
                  document: document,
                  suite: this,
                  verificationMethod: verificationMethod,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 15:
                purposeResult = _context3.sent;

                if (purposeResult.valid) {
                  _context3.next = 18;
                  break;
                }

                throw purposeResult.error;

              case 18:
                return _context3.abrupt("return", {
                  verified: true,
                  purposeResult: purposeResult
                });

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](1);
                return _context3.abrupt("return", {
                  verified: false,
                  error: _context3.t0
                });

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 21]]);
      }));

      function verifyProof(_x3) {
        return _verifyProof.apply(this, arguments);
      }

      return verifyProof;
    }()
  }, {
    key: "canonize",
    value: function () {
      var _canonize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input, _ref5) {
        var documentLoader, expansionMap, skipExpansion;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                documentLoader = _ref5.documentLoader, expansionMap = _ref5.expansionMap, skipExpansion = _ref5.skipExpansion;
                return _context4.abrupt("return", jsonld.canonize(input, {
                  algorithm: 'URDNA2015',
                  format: 'application/n-quads',
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  skipExpansion: skipExpansion,
                  useNative: this.useNativeCanonize
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function canonize(_x4, _x5) {
        return _canonize.apply(this, arguments);
      }

      return canonize;
    }()
  }, {
    key: "canonizeProof",
    value: function () {
      var _canonizeProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(proof, _ref6) {
        var documentLoader, expansionMap;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                documentLoader = _ref6.documentLoader, expansionMap = _ref6.expansionMap;
                // `jws`,`signatureValue`,`proofValue` must not be included in the proof
                // options
                proof = _objectSpread({}, proof);
                delete proof.jws;
                delete proof.signatureValue;
                delete proof.proofValue;
                return _context5.abrupt("return", this.canonize(proof, {
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  skipExpansion: false
                }));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function canonizeProof(_x6, _x7) {
        return _canonizeProof.apply(this, arguments);
      }

      return canonizeProof;
    }()
    /**
     * @param document {object} to be signed/verified.
     * @param proof {object}
     * @param documentLoader {function}
     * @param expansionMap {function}
     * @param compactProof {boolean}
     *
     * @returns {Promise<{Uint8Array}>}.
     */

  }, {
    key: "createVerifyData",
    value: function () {
      var _createVerifyData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref7) {
        var document, proof, documentLoader, expansionMap, c14nProofOptions, c14nDocument;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                document = _ref7.document, proof = _ref7.proof, documentLoader = _ref7.documentLoader, expansionMap = _ref7.expansionMap;
                _context6.next = 3;
                return this.canonizeProof(proof, {
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 3:
                c14nProofOptions = _context6.sent;
                _context6.next = 6;
                return this.canonize(document, {
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 6:
                c14nDocument = _context6.sent;
                return _context6.abrupt("return", util.concat(util.sha256(c14nProofOptions), util.sha256(c14nDocument)));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createVerifyData(_x8) {
        return _createVerifyData.apply(this, arguments);
      }

      return createVerifyData;
    }()
    /**
     * @param document {object} to be signed.
     * @param proof {object}
     * @param documentLoader {function}
     * @param expansionMap {function}
     */

  }, {
    key: "getVerificationMethod",
    value: function () {
      var _getVerificationMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref8) {
        var proof, documentLoader, verificationMethod, creator, _yield$jsonld$frame, _yield$jsonld$frame$, framed;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                proof = _ref8.proof, documentLoader = _ref8.documentLoader;
                verificationMethod = proof.verificationMethod;

                if (!verificationMethod) {
                  // backwards compatibility support for `creator`
                  creator = proof.creator;
                  verificationMethod = creator;
                }

                if (typeof verificationMethod === 'object') {
                  verificationMethod = verificationMethod.id;
                }

                if (verificationMethod) {
                  _context7.next = 6;
                  break;
                }

                throw new Error('No "verificationMethod" or "creator" found in proof.');

              case 6:
                _context7.next = 8;
                return jsonld.frame(verificationMethod, {
                  '@context': constants.SECURITY_CONTEXT_URL,
                  '@embed': '@always',
                  id: verificationMethod
                }, {
                  documentLoader: documentLoader,
                  compactToRelative: false
                });

              case 8:
                _yield$jsonld$frame = _context7.sent;
                _yield$jsonld$frame$ = _slicedToArray(_yield$jsonld$frame['@graph'], 1);
                framed = _yield$jsonld$frame$[0];

                if (framed) {
                  _context7.next = 13;
                  break;
                }

                throw new Error("Verification method ".concat(verificationMethod, " not found."));

              case 13:
                if (!(framed.revoked !== undefined)) {
                  _context7.next = 15;
                  break;
                }

                throw new Error('The verification method has been revoked.');

              case 15:
                return _context7.abrupt("return", framed);

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getVerificationMethod(_x9) {
        return _getVerificationMethod.apply(this, arguments);
      }

      return getVerificationMethod;
    }()
    /**
     * @param verifyData {Uint8Array}.
     * @param document {object} to be signed.
     * @param proof {object}
     * @param documentLoader {function}
     * @param expansionMap {function}
     *
     * @returns {Promise<{object}>} the proof containing the signature value.
     */

  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                throw new Error('Must be implemented by a derived class.');

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function sign() {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
    /**
     * @param verifyData {Uint8Array}.
     * @param verificationMethod {object}.
     * @param document {object} to be signed.
     * @param proof {object}
     * @param documentLoader {function}
     * @param expansionMap {function}
     *
     * @returns {Promise<boolean>}
     */

  }, {
    key: "verifySignature",
    value: function () {
      var _verifySignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                throw new Error('Must be implemented by a derived class.');

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function verifySignature() {
        return _verifySignature.apply(this, arguments);
      }

      return verifySignature;
    }()
  }]);

  return LinkedDataSignature;
}(LinkedDataProof);